import axios from "../Helpers/axiosinstance";
import { fetchWrapper } from "../Helpers/fetch-wrapper";

const sanctumCsrfCookie = async () => {
  return axios.get("csrf-cookie", {
    withCredentials: true,
  });
};

const changePassword = async (params) => {
  return fetchWrapper.put(
    `${process.env.REACT_APP_API_ENDPOINT}/user/password`,
    {
      email: params.email || undefined,
      new_password: params.new_pass || undefined,
    }
  );
};

const getAllRoles = async () => {
  return fetchWrapper.get(`${process.env.REACT_APP_API_ENDPOINT}/role`);
};

export const AuthService = {
  sanctumCsrfCookie,
  changePassword,
  getAllRoles,
};

